import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { PedidoStatus, PedidoStatusFluxo } from './models/pedido-status';
import { Perfil } from '../usuario/models/usuario';

@Injectable({
    providedIn: 'root'
})

export class PedidoStatusService {

    private environmentUrl: string = '';

    constructor(private httpClient: HttpClient) {
        this.environmentUrl = environment.ApiCore;
    }

    getFluxo(): Observable<PedidoStatusFluxo[]> {
        let url = this.environmentUrl + "/PedidoStatusFluxo/ListaCompleta";
        return this.httpClient.get<PedidoStatusFluxo[]>(url);
    }

    addFluxo(newFluxo: PedidoStatusFluxo) {
        return this.httpClient.post(this.environmentUrl + "/PedidoStatusFluxo", newFluxo);
    }

    updFluxo(fluxo: PedidoStatusFluxo) {
        return this.httpClient.put(this.environmentUrl + "/PedidoStatusFluxo", fluxo);
    }

    delFluxo(fluxo: PedidoStatusFluxo) {
        return this.httpClient.delete(this.environmentUrl + "/PedidoStatusFluxo/" + fluxo.idPedidoStatusFluxo);
    }

    // updFluxoPerfil(listaPerfil: string) {
    //     return this.httpClient.put(this.environmentUrl + "/PedidoStatusFluxo/PerfilAcesso/", listaPerfil);
    // }

    updFluxoPerfil(selectedPerfil: Perfil[], idPedidoStatusFluxo: number) {    
        return this.httpClient.put(this.environmentUrl + "/PedidoStatusFluxo/PerfilAcesso/"+idPedidoStatusFluxo, selectedPerfil);
    }

    getStatus(): Observable<PedidoStatus[]> {
        let url = this.environmentUrl + "/PedidoStatus";
        return this.httpClient.get<PedidoStatus[]>(url);
    }

    getSelectedStatus(id: number) : Observable<PedidoStatus>{
        let url = this.environmentUrl+"/PedidoStatus/"+id;        
        return this.httpClient.get<PedidoStatus>(url);
      }

    getPerfil(): Observable<Perfil[]> {
        let url = this.environmentUrl + "/Perfil";
        return this.httpClient.get<Perfil[]>(url);
    }

    getPerfilChecked(idPedidoStatusFluxo: number): Observable<Perfil[]> {
        let url = this.environmentUrl + "/PedidoStatusFluxo/Perfil/"+idPedidoStatusFluxo;
        return this.httpClient.get<Perfil[]>(url);
    }

    getSelectedPerfil(id: number): Observable<Perfil> {
        let url = this.environmentUrl + "/Perfil/" + id;
        return this.httpClient.get<Perfil>(url);
    }

}


